<template>
    <div class="what_zhima">
        <Header tit="什么是芝麻信用" color="1"></Header>
        <div class="container margin-t30">
            <div class="page">
                <div class="header">
                    <img src="https://os.alipayobjects.com/rmsportal/dJyTlCRqRfCxUVf.png" />
                    <p class="content">
                        芝麻信用是独立的第三方信用服务机构，在合法合规与用户授权的前提下，为各类生活与金融服务提供信用评估能力，帮助降低交易成本、提升服务效率。良好的信用有助于您获得更便捷的服务体验。
                    </p>
                </div>
                <div class="box box-1">
                    <h3 class="title">芝麻分</h3>
                    <p class="txt">
                        芝麻分是对用户信用状况的综合评分（常见区间为 350～950，具体以支付宝展示为准）。分数越高，通常代表信用状况越好，在支持的场景中可能享受更高效、更优质的服务。
                    </p>
                    <img src="https://os.alipayobjects.com/rmsportal/xidrMrQSpUlavDl.png" />
                </div>
                <div class="box box-2">
                    <h3 class="title">如何查看</h3>
                    <p class="txt">您可在支付宝 App 的「芝麻信用」相关入口查看；部分合作商户在获得您授权后，也可在合规范围内参考您的信用评估结果。</p>
                    <p class="txt">未经您授权同意，芝麻信用不会向无关第三方披露您的个人敏感信用信息。</p>
                    <img src="https://os.alipayobjects.com/rmsportal/dCAdDNQEShdbnmL.png" />
                </div>
                <div class="box box-3">
                    <h3 class="title">信用如何帮助您</h3>
                    <p class="txt">金融机构与服务平台可在合规授权下参考信用评估结果，更快完成审核决策，并为您提供更匹配的服务方案。</p>
                    <p class="txt">良好的信用记录有助于您在租房、出行、消费分期等场景中减少繁琐流程。</p>
                    <img src="https://os.alipayobjects.com/rmsportal/VGcVLnLkUMMIicS.png" />
                </div>
                <div class="box box-4">
                    <h3 class="title">如何提升信用</h3>
                    <p class="txt">
                        信用积累是长期过程，需保持良好履约习惯：按时还款、合理使用信贷产品、完善真实有效的个人信息等，都有助于形成更完整的信用画像。请警惕任何声称「快速刷分」的违规操作。
                    </p>
                    <img src="https://os.alipayobjects.com/rmsportal/RQDZipmgezVUrsq.png" />
                </div>
                <a
                    href="http://d.alipay.com/i/index.htm?iframeSrc=alipays%3A%2F%2Fplatformapi%2FstartApp%3FappId%3D20000118%26target%3Dcredit"
                    class="footer"
                >了解更多请前往支付宝钱包客户端芝麻信用 &gt;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
            </div>
        </div>
    </div>
</template>
<script>
import Header from "../public/header";
export default {
    components: { Header },
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
a {
    text-decoration: none;
}
h3,
p {
    margin: 0 15px;
    text-align: left;
    line-height: 25px;
    font-size: 14px;
}
h3 {
    margin: 20px 15px 5px;
    font-size: 16px;
    color: #000;
}
.page {
    color: #666;
    font-family: "Microsoft Yahei";
    font-size: 15px;
}
.header,
.footer {
    text-align: center;
}
.footer {
    height: 40px;
    line-height: 32px;
    text-align: center;
    color: #a5a5a5;
    font-size: 12px;
    display: block;
}
.header .content {
    color: #8f8f95;
}
.header img {
    width: 39%;
    margin: 10% 0 5%;
}
.header .ps {
    margin-bottom: 10px;
}
.box img {
    width: 100%;
    margin: 20px 0 10px;
}
.box .txt {
    color: #666;
}
.box-4 {
    margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/my/what_zhima.vue